import { notificationSuccess } from "../components/Notifications/callNotifcation"

export const copyToClipboard = (text: string) => {
    navigator.clipboard.writeText(text)
    notificationSuccess('Текст скопирован в буфер обмена!');
}
